// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.exit-reading-button {
  float: left;
  width: 125px;
  height: 37px;
  background: rgba(146, 146, 146, 1);
  opacity: 1;
  margin-top: 11px;
  margin-left: 18px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 500;
}
.operation-button-container {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 80%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.exit-reading-icon {
  display: inline-block;
  font-size: 21px;
  margin-right: 10px;
}
.exit-reading-text {
  font-size: 13px;
  line-height: 37px;
  opacity: 1;
}
.add-bookmark-button {
  float: left;
  width: 125px;
  height: 37px;
  background: rgba(92, 143, 211, 0.83);
  opacity: 1;
  margin-top: 11px;
  margin-left: 20px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.add-bookmark-icon {
  font-size: 20px;
  margin-left: 5px;
}
.add-bookmark-text {
  font-size: 13px;
  line-height: 14px;
  opacity: 1;
  margin-left: 10px;
  display: block;
  width: 70%;
}
.enter-fullscreen-button {
  float: left;
  width: 125px;
  height: 37px;
  background: rgba(94, 178, 148, 1);
  opacity: 1;
  margin-top: 11px;
  margin-left: 20px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.enter-fullscreen-icon {
  font-size: 19px;
  margin-left: 5px;
}
.enter-fullscreen-text {
  font-size: 13px;
  line-height: 14px;
  opacity: 1;
  margin-left: 10px;
}
.book-operation-panel {
  width: 450px !important;
  height: 90px;
  opacity: 1;
  position: absolute;
  top: 0px;
  left: calc(50% - 225px);
  z-index: 10;
  animation: fade-down 0.1s ease-in-out 0s 1;
}
.book-opeartion-info {
  text-align: center;
  line-height: 25px;
  margin-top: 7px;
  font-size: 15px;
}
`, "",{"version":3,"sources":["webpack://./src/containers/panels/operationPanel/operationPanel.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kCAAkC;EAClC,UAAU;EACV,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,UAAU;AACZ;AACA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,oCAAoC;EACpC,UAAU;EACV,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,UAAU;EACV,iBAAiB;EACjB,cAAc;EACd,UAAU;AACZ;AACA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,iCAAiC;EACjC,UAAU;EACV,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,UAAU;EACV,iBAAiB;AACnB;AACA;EACE,uBAAuB;EACvB,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,QAAQ;EACR,uBAAuB;EACvB,WAAW;EACX,0CAA0C;AAC5C;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;AACjB","sourcesContent":[".exit-reading-button {\n  float: left;\n  width: 125px;\n  height: 37px;\n  background: rgba(146, 146, 146, 1);\n  opacity: 1;\n  margin-top: 11px;\n  margin-left: 18px;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-weight: 500;\n}\n.operation-button-container {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  width: 80%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.exit-reading-icon {\n  display: inline-block;\n  font-size: 21px;\n  margin-right: 10px;\n}\n.exit-reading-text {\n  font-size: 13px;\n  line-height: 37px;\n  opacity: 1;\n}\n.add-bookmark-button {\n  float: left;\n  width: 125px;\n  height: 37px;\n  background: rgba(92, 143, 211, 0.83);\n  opacity: 1;\n  margin-top: 11px;\n  margin-left: 20px;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-weight: 500;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.add-bookmark-icon {\n  font-size: 20px;\n  margin-left: 5px;\n}\n.add-bookmark-text {\n  font-size: 13px;\n  line-height: 14px;\n  opacity: 1;\n  margin-left: 10px;\n  display: block;\n  width: 70%;\n}\n.enter-fullscreen-button {\n  float: left;\n  width: 125px;\n  height: 37px;\n  background: rgba(94, 178, 148, 1);\n  opacity: 1;\n  margin-top: 11px;\n  margin-left: 20px;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-weight: 500;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.enter-fullscreen-icon {\n  font-size: 19px;\n  margin-left: 5px;\n}\n.enter-fullscreen-text {\n  font-size: 13px;\n  line-height: 14px;\n  opacity: 1;\n  margin-left: 10px;\n}\n.book-operation-panel {\n  width: 450px !important;\n  height: 90px;\n  opacity: 1;\n  position: absolute;\n  top: 0px;\n  left: calc(50% - 225px);\n  z-index: 10;\n  animation: fade-down 0.1s ease-in-out 0s 1;\n}\n.book-opeartion-info {\n  text-align: center;\n  line-height: 25px;\n  margin-top: 7px;\n  font-size: 15px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
